import * as angular from "angular";
import {IController} from 'angular';
import {AnalyticsService} from "../../../../commons/services/analytics-service.service";

export class ReportsDemandFiltersPanelCtrl implements IController {
  // from: any;
  // to: any;
  branchId: any;
  demandIds: any;
  onFiltersChange: Function;

  constructor(private $mdPanel, private $state, private splitService, private moment) {
  }

  $onInit() {
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.demand-filters-panel')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          siteId: this.splitService.getSiteId(),
          // from: new Date(this.from),
          // to: new Date(this.to),
          branchId: this.branchId,
          demandIds: this.demandIds || [],
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: DemandFiltersPanelCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/reports/components/panels/reports-demand-filters-panel/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel, reason) {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(filterConfig, parentScope) {
    parentScope.onFiltersChange({
      // from: filterConfig.from,
      // to: filterConfig.to,
      branchId: filterConfig.branchId,
      demandIds: filterConfig.demandIds,
    })
  }


}

class DemandFiltersPanelCtrl implements IController {

  private siteId: any;
  private filterConfig: any;

  constructor(private mdPanelRef, private analyticsService: AnalyticsService, private splitService, private moment, private $state) {
    this.siteId = this.mdPanelRef.config.locals.data.siteId;
  }

  $onInit() {
    this.filterConfig = {
      // from: this.mdPanelRef.config.locals.data.from,
      // to: this.mdPanelRef.config.locals.data.to,
      branchId: this.mdPanelRef.config.locals.data.branchId,
      demandIds: this.mdPanelRef.config.locals.data.demandIds
    };
  }

  ///////////////////////////////////////////////////////////////////////////////////////

  // onDateChanged() {
  //   if (this.filterConfig.from > this.filterConfig.to) {
  //     this.filterConfig.to = angular.copy(this.filterConfig.from);
  //   }
  // }

  onChangeBranchId(branchId) {
    this.filterConfig.branchId = branchId;
    this.filterConfig.demandIds = [];
  }

  onChangeDemandIds(demandIds) {
    this.filterConfig.demandIds = demandIds;
  }


  onReset() {
    this.filterConfig = {
      // from: this.filterConfig.from,
      // to: this.filterConfig.to,
      branchId: undefined,
      demandIds: []
    };
    this.submit()
  }

  submit() {
    this.mdPanelRef.close()
      .then((mdPanelRef) => {
        // const from = this.moment(this.filterConfig.from).startOf('day').valueOf();
        // const to = this.moment(this.filterConfig.to).endOf('day').valueOf();
        const filterConfig = {
          // from: from,
          // to: to,
          branchId: this.filterConfig.branchId,
          demandIds: this.filterConfig.demandIds
        };
        mdPanelRef.config.locals.onClose(filterConfig, this.mdPanelRef.config.locals.data.parentScope);
        // this.$state.go('.', {from: from, to: to}, {notify: false, reload: false});
      })
  }

  cancel() {
    this.mdPanelRef.close();
  }

}

angular
  .module('bringoz.admin.reports')
  .component('reportsDemandFiltersPanel', {
    bindings: {
      // from: '<',
      // to: '<',
      branchId: '<',
      demandIds: '<',
      onFiltersChange: '&'
    },
    template: require('./reports-demand-filters-panel.html').default,
    controller: ReportsDemandFiltersPanelCtrl
  });
